
  <h3>{{data.head}}</h3>
    <hr>
    <p [innerHtml]="data.body.replace('##', data.item? '<strong>'+data.item+'</strong>': 'this item')"> </p>
    <div class="row a-center">

      <mat-form-field class="col-9" >
      <mat-label>{{data.head}}
      </mat-label>
      <mat-select formControlName="assignUser" multiple="!data.single" (valueChange)='handleChange($event)'>
        <mat-option *ngFor="let item of  data?.options" [value]="item">
          {{item.optionName}} </mat-option>
      </mat-select>
    </mat-form-field>

      <div class="col-3">
        <button mat-raised-button (click)="submit()" color="primary">Submit</button>
        <!-- <button mat-button (click)="onNoClick()" cdkFocusInitial class="ml-2">Cancel</button> -->
      </div>
    </div>
    <button class="close" mat-icon-button (click)="onNoClick()"><mat-icon>close</mat-icon></button>
    